export default __webpack_public_path__ + "static/media/spotifyclone.8ac4e7de.png";